import React, { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useOrder } from 'api/calc';
import { ROUTES } from 'config/constants';
import { isDemoPage } from 'utils/hooks';

const CalculationReadOnlyContext = createContext(false);

export const CalculationReadOnlyProvider = ({ children }: CalculationReadOnlyProviderProps) => {
  const { pathname } = useLocation();
  const order = useOrder();

  const value = useMemo(() => {
    if (isDemoPage()) {
      return false;
    }

    const isStaffView = pathname.includes(`/${ROUTES.CABINET}/${ROUTES.CALCULATOR_VIEW}/`);
    const lockedByApplication = Boolean(order?.locked_by_active_application);

    return isStaffView || lockedByApplication;
  }, [ pathname, order?.locked_by_active_application ]);

  return (
    <CalculationReadOnlyContext.Provider value={value}>
      {children}
    </CalculationReadOnlyContext.Provider>
  );
};

export const useCalculationReadOnly = () => useContext(CalculationReadOnlyContext);
